import { Injectable } from '@angular/core';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { saveAs } from 'file-saver';
import { IStatistic2ReportViewParams } from '@fi-app/statistic2/statistic2-report-view/statistic2-report-view';
import { FiImageSize, FileType } from '@fi-shared/types';
import { FiPrintDownloadService } from '@fi-shared/fi-print-download/fi-print-download.service';

@Injectable()
export class Statistic2ReportService {
    constructor(private fiPrintDownloadService: FiPrintDownloadService) {}

    downloadExtendedReport(reportViewParams: IStatistic2ReportViewParams) {
        const url = `Statistic/Statistic2/DownloadExtendedReport`;
        const fileName = this.fiPrintDownloadService.getReportFileName('report', FileType.Excel);

        const promise = this.fiPrintDownloadService.downloadBinaryFile(url, {
            fileName: fileName,
            size: FiImageSize.Original,
            data: reportViewParams,
        });
        return promise;
    }
}
